// Config
export const IS_WINDOW = 'object' === typeof window
export const ENV = IS_WINDOW && window.location.href.match('//localhost') ? 'dev' : 'prod'
export const IS_DEV = ENV == 'dev'
// Don't use a trailing slash for API_BASE_URLs
export const API_BASE_URL_DEV = 'http://localhost:8001'
export const API_BASE_URL_PROD = 'https://api.nodejobs.net'
export const API_BASE_URL = IS_DEV ? API_BASE_URL_DEV : API_BASE_URL_PROD
export const STRIPE_PUBLISHABLE_KEY = (IS_DEV) ? 'pk_test_vEBcNmUf0ayyWLpHgEbmD8C400FZJ9GvAQ' : 'pk_live_51HWTzMDILqQmAHtEkrOS9n0auWbrx9bbAOLVh0KBIYrrnkb1MqR6jRwkFA6eCfBeHGUVjjMBmXOxPPuqVWT5b3cf00QkFQYfdN'
export const MONTH_MAP = {
    1: 'January',
    2: 'February',
    3: 'March',
    4: 'April',
    5: 'May',
    6: 'June',
    7: 'July',
    8: 'August',
    9: 'September',
    10: 'October',
    11: 'November',
    12: 'December'
}
